module.exports = __webpack_public_path__ + "static/de-graaff-logo-kleur.1ff799b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/de-graaff-logo-kleur.svg
// module id = 128
// module chunks = 35783957827783 215951927083960